const size = {
  xs: '575px',
  sm: '768px',
  md: '992px',
  lg: '1200px',
};

const devices = {
  xs: `(max-width: ${size.xs})`,
  sm: `(max-width: ${size.sm})`,
  md: `(max-width: ${size.md})`,
  lg: `(max-width: ${size.lg})`,
};

export default devices;
